import { Badge, BadgeProps, styled, Tooltip } from '@mui/material';
import { TaskListCategory } from '../types';
import { rgbaPrimary } from 'constants/colors';

interface StyledBadgeProps extends BadgeProps {
  categoryColor?: string;
}

// change styledBade to receive a prop
const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'categoryColor'
})<StyledBadgeProps>(({ categoryColor }) => ({
  '& .MuiBadge-badge': {
    top: 11,
    left: 12,
    padding: '0 4px',
    backgroundColor: categoryColor || 'transparent',
    position: 'relative',
    width: '24px',
    height: '24px',
    lineHeight: '24px',
    fontSize: '12px',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: `0 0 1px 2px ${rgbaPrimary(0.2)}`
    }
  }
}));

type CategoryBadgeProps = {
  category: TaskListCategory;
  count: number;
  getCategoryColor: (category: TaskListCategory) => string;
  handleSingleOpenCategory: () => void;
  label: string;
};

export const CategoryBadgeWithTooltip = ({
  category,
  count,
  getCategoryColor,
  handleSingleOpenCategory,
  label
}: CategoryBadgeProps) => (
  <Tooltip title={label}>
    <StyledBadge
      categoryColor={getCategoryColor(category)}
      badgeContent={count}
      onClick={handleSingleOpenCategory}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    />
  </Tooltip>
);
